<app-breadcrumb
  [path]="'Checkout Confiável'"
  [showTitle]="true"
></app-breadcrumb>

<div class="payment-main">
  <div class="container">
    <div class="payment-main-content">
      <div class="payment-main-content-address">
        <h2>CONTATO</h2>
        <div class="payment-main-content-address-contact" *ngIf="!budget.hash">
          <p-checkbox
            label="Compra com CNPJ"
            inputId="isCompany"
            name="isCompany"
            [(ngModel)]="user.isCompany"
            value="{{ user.isCompany }}"
            [binary]="true"
          />
          <p-inputMask
            (onComplete)="onCompleteDocument()"
            placeholder="{{ user.isCompany ? 'Seu CNPJ' : 'Seu CPF' }}"
            ariaLabel="{{ user.isCompany ? 'Seu CNPJ' : 'Seu CPF' }}"
            mask="{{
              user.isCompany ? '99.999.999/9999-99' : '999.999.999-99'
            }}"
            name="document"
            id="document"
            [required]="true"
            [(ngModel)]="user.document"
            [ngClass]="{
              'error-input-mask': userError.errorDocument
            }"
          ></p-inputMask>
          <input
            aria-label="Informe seu nome"
            placeholder="Nome"
            type="text"
            required
            name="name"
            pInputText
            [(ngModel)]="user.name"
            [ngClass]="{
              'error-input': userError.errorName
            }"
          />
          <input
            placeholder="E-mail"
            aria-label="Informe seu e-mail"
            type="email"
            name="email"
            required
            pInputText
            [(ngModel)]="user.email"
            [ngClass]="{
              'error-input': userError.errorEmail
            }"
          />
          <p-inputMask
            ariaLabel="Informe seu telefone com DDD"
            placeholder="Telefone com DDD"
            mask="(99) 99999-9999"
            name="phone"
            id="phone"
            [required]="true"
            [(ngModel)]="user.phone"
            [ngClass]="{
              'error-input-mask': userError.errorPhone
            }"
          ></p-inputMask>
          <p-checkbox
            label="Quero receber novidades e ofertas por e-mail"
            [(ngModel)]="acceptNewsletter"
            [binary]="true"
          />
        </div>

        <div
          class="payment-main-content-address-contact-budget"
          *ngIf="budget.hash"
        >
          <input
            *ngIf="showName"
            placeholder="Nome"
            aria-label="Informe seu Nome"
            type="name"
            name="name"
            required
            pInputText
            [(ngModel)]="user.name"
            [ngClass]="{
              'error-input': userError.errorName
            }"
          />

          <p *ngIf="!showName">
            Nome: <span>{{ user.name }}</span>
          </p>

          <p *ngIf="!showAdditionalData || !showDocument">
            {{ user.isCompany ? "CNPJ:" : "CPF:" }}
            <span>{{ user.documentFormat() }}</span>
          </p>
          <p-inputMask
            *ngIf="showAdditionalData && showDocument"
            (onComplete)="onCompleteDocument()"
            ariaLabel="Informe seu CPF"
            placeholder="CPF"
            mask="999.999.999-99"
            name="document"
            id="document"
            [required]="true"
            [(ngModel)]="user.document"
            [ngClass]="{
              'error-input-mask': userError.errorDocument
            }"
          ></p-inputMask>
          <p *ngIf="!showAdditionalData || !showEmail">
            E-mail: <span>{{ user.email }}</span>
          </p>
          <input
            *ngIf="showAdditionalData && showEmail"
            placeholder="E-mail"
            aria-label="Informe seu e-mail"
            type="email"
            name="email"
            required
            pInputText
            [(ngModel)]="user.email"
            [ngClass]="{
              'error-input': userError.errorEmail
            }"
          />
          <p>
            Telefone: <span>{{ user.phone }}</span>
          </p>
        </div>
        <h2 *ngIf="!budget.hash">ENTREGA</h2>
        <div class="payment-main-content-address-main" *ngIf="!budget.hash">
          <app-address
            [address]="address"
            [addressError]="addressError"
            [addressDisable]="addressDisable"
            [showKnowZipCoded]="false"
            [showLabel]="false"
            (clearedZip)="clearedZip()"
            (foundAddress)="foundAddress($event)"
          ></app-address>

          <app-freight-quotes-desktop
            [loadingFreight]="loadingFreight"
            [quotes]="quotes"
            [freightSelected]="cartCheckout?.freightSelected"
            (onChangeFreightSelected)="setFreightSelectedDesktop($event)"
          ></app-freight-quotes-desktop>
        </div>

        <div class="payment-main-content-address-budget" *ngIf="isBudget()">
          <h2 *ngIf="showAddressInvoicing()">ENDEREÇO DE FATURAMENTO</h2>
          <p *ngIf="budget.addressInvoicing">
            Faturamento:
            <span [innerHTML]="budget.addressInvoicing.getAddressDescription()">
            </span>
          </p>

          <h2>
            {{
              budget.user?.isCompany && !showAddressInvoicing()
                ? "ENDEREÇO"
                : "ENDEREÇO DE ENTREGA:"
            }}
          </h2>
          <p>
            Rua:
            <span>{{ budget.addressDelivery?.address }}</span>
          </p>
          <p *ngIf="!!budget.addressDelivery?.numberAddress">
            Número:
            <span>{{ budget.addressDelivery?.numberAddress }}</span>
          </p>

          <p
            class="payment-main-content-address-budget-additional"
            *ngIf="
              !budget.addressDelivery?.numberAddress ||
              !budget.addressDelivery?.complement
            "
          >
            <input
              class="address-budget-number"
              *ngIf="!budget.addressDelivery?.numberAddress"
              aria-label="Número"
              placeholder="Número"
              type="text"
              required
              name="numberAddress"
              id="numberAddress"
              pInputText
              [(ngModel)]="address.numberAddress"
              [ngClass]="{
                'error-input': !address.numberAddress
              }"
            />

            <input
              class="address-budget-complement"
              *ngIf="!budget.addressDelivery?.complement"
              placeholder="Complemento"
              aria-label="Complemento"
              type="text"
              name="complement"
              id="complement"
              required
              pInputText
              [maxLength]="20"
              [(ngModel)]="address.complement"
              [ngClass]="{
                'error-input': (address.complement?.length || 0) < 2
              }"
            />
          </p>
          <p *ngIf="!!budget.addressDelivery?.complement">
            Complemento:
            <span>{{ budget.addressDelivery?.complement }}</span>
          </p>
          <p>
            Bairro:
            <span>{{ budget.addressDelivery?.district }}</span>
          </p>
          <p>
            Cidade:
            <span>{{ budget.addressDelivery?.city }} | </span>UF:
            <span>{{ budget.addressDelivery?.uf }}</span>
          </p>
          <p>
            CEP:
            <span>{{ budget.addressDelivery?.zipCode }}</span>
          </p>

          <div class="payment-main-content-address-budget-carrier">
            <p>
              Transportadora:
              <span>{{ budget.carrierDescription }}</span>
            </p>
            <p>
              Valor:
              <span
                >{{ budget.valueFreight | customCurrencyLight }} em
                {{ budget.deliveryTime }} dias úteis</span
              >
            </p>
            <p>
              {{ budget.volume }} volume(s) com peso total de
              {{ getTotalWeight() }} kg
            </p>
          </div>
        </div>
        <h2 *ngIf="budget.hash && budget.observations">OBSERVAÇÕES</h2>
        <div
          *ngIf="budget.hash && budget.observations"
          class="p-editor-content ql-container ql-snow"
        >
          <div
            class="ql-editor"
            [innerHTML]="budget.observations | safe : 1"
          ></div>
        </div>
      </div>
      <div class="payment-main-content-payment">
        <div class="payment-main-content-payment-methods">
          <h2>PAGAMENTO</h2>
          <div class="payment-main-content-payment-methods-pix">
            <p-checkbox
              label="Pix"
              name="paymentMethod"
              value="PIX"
              [binary]="true"
              [ngModel]="paymentSelected === 'PIX'"
              (onChange)="selectPayment('PIX')"
            />
            <img
              src="https://d20p8exwoll05u.cloudfront.net/assets/images/icon/pix-48.png"
              alt="Logo Pix"
              width="22"
              height="22"
            />
          </div>
          <div class="payment-main-content-payment-methods-card">
            <div class="payment-main-content-payment-methods-card-check">
              <p-checkbox
                label="Cartão de crédito"
                name="paymentMethod"
                value="CARTAO_CREDITO"
                [binary]="true"
                [ngModel]="paymentSelected === 'CARTAO_CREDITO'"
                (onChange)="selectPayment('CARTAO_CREDITO')"
              />
              <img
                src="https://d20p8exwoll05u.cloudfront.net/assets/images/icon/visa-48.png"
                alt="Logo Pix"
                width="32"
                height="23"
              /><img
                src="https://d20p8exwoll05u.cloudfront.net/assets/images/icon/mastercard-48.png"
                alt="Logo Pix"
                width="32"
                height="23"
              /><img
                src="https://d20p8exwoll05u.cloudfront.net/assets/images/icon/elo-48.png"
                alt="Logo Pix"
                width="32"
                height="23"
              />
              <img
                src="https://d20p8exwoll05u.cloudfront.net/assets/images/icon/amex-48.png"
                alt="Logo Pix"
                width="32"
                height="23"
              />
              <p>4+</p>
            </div>
            <app-credit-card-input
              [disabled]="paymentSelected === 'PIX'"
              [card]="card"
              [cardInputError]="cardInputError"
              [installments]="installments"
              (onChangeInstallments)="payeCostSelected = $event"
            ></app-credit-card-input>
          </div>
        </div>

        <div class="payment-main-content-payment-same-address">
          <p-checkbox
            [(ngModel)]="sameAddressForInvoice"
            [binary]="true"
            label="Usar o endereço de entrega como de faturamento"
          />
        </div>

        <div class="payment-main-content-payment-coupon" *ngIf="!budget.hash">
          <input
            placeholder="Informe seu cupom"
            aria-label="Cupom desconto"
            type="text"
            name="coupon"
            pInputText
            [(ngModel)]="coupon"
          />
          <button
            (click)="onClickBtcalculateCoupon()"
            title="Calcular cupom desconto"
            class="button-rm"
            aria-label="Calcular cupom desconto"
          >
            USAR
          </button>
        </div>

        <div class="payment-main-content-payment-resume">
          <div class="payment-resume-totals">
            <div class="payment-resume-subtotal">
              <p>Valor total s/ desconto</p>
              <p>
                {{ cartCheckout?.gross || 0 | customCurrencyLight }}
              </p>
            </div>

            <div class="payment-resume-subtotal" *ngIf="couponDiscount">
              <p>
                Cupom: {{ couponDiscount.coupon?.code
                }}<span
                  class="payment-resume-subtotal-coupon"
                  (click)="onClickBtRemoveCoupon()"
                  >Remover</span
                >
              </p>
              <p>
                {{ couponDiscount.totalDiscount || 0 | customCurrencyLight }}
              </p>
            </div>
            <div
              class="payment-resume-subtotal"
              *ngIf="haveProductDiscount() && !couponDiscount && !budget"
            >
              <p class="payment-resume-subtotal-discount">Desconto aplicado</p>
              <p class="payment-resume-subtotal-discount">
                -
                {{ cartCheckout?.discount | customCurrencyLight }}
              </p>
            </div>

            <div
              class="payment-resume-subtotal"
              *ngIf="
                budget &&
                budget.cart?.haveProductDiscount &&
                paymentSelected === 'PIX' &&
                !couponDiscount
              "
            >
              <p class="payment-resume-subtotal-discount">
                Desconto produtos à vista ({{
                  budget.cart?.percentDiscountProduct
                }}%)
              </p>
              <p class="payment-resume-subtotal-discount">
                -
                {{ budget.cart?.valueDiscount | customCurrencyLight }}
              </p>
            </div>

            <div
              class="payment-resume-subtotal"
              *ngIf="
                budget &&
                (budget.cart?.discountSeller || 0) > 0 &&
                paymentSelected === 'PIX' &&
                !couponDiscount
              "
            >
              <p class="payment-resume-subtotal-discount">
                Desconto Vendedor ({{ budget.discountSeller }}%)
              </p>
              <p class="payment-resume-subtotal-discount">
                -
                {{ budget.cart?.valueDiscountSeller | customCurrencyLight }}
              </p>
            </div>
            <div
              class="payment-resume-subtotal"
              *ngIf="(budget.availableCredit || 0) > 0"
            >
              <p class="payment-resume-subtotal-discount">Crédito cliente</p>
              <p class="payment-resume-subtotal-discount">
                -
                {{ budget.availableCredit | customCurrencyLight }}
              </p>
            </div>

            <div
              *ngIf="(budget.additionalValue || 0) > 0"
              class="payment-resume-subtotal"
            >
              <p>Acréscimo</p>
              <p>
                +
                {{ budget.additionalValue | customCurrencyLight }}
              </p>
            </div>
            <div
              *ngIf="
                (cartCheckout?.freightSelected?.freight?.priceFreight || 0) > 0
              "
              class="payment-resume-subtotal"
            >
              <p>Frete</p>
              <p>
                +
                {{
                  cartCheckout?.freightSelected?.freight?.priceFreight || 0
                    | customCurrencyLight
                }}
              </p>
            </div>

            <div
              *ngIf="(budget.valueFreight || 0) > 0"
              class="payment-resume-subtotal"
            >
              <p>Frete</p>
              <p>
                +
                {{ budget.valueFreight || 0 | customCurrencyLight }}
              </p>
            </div>

            <div
              class="payment-resume-subtotal"
              *ngIf="(payeCostSelected?.installments || 0) > 3"
            >
              <p>Juros</p>
              <p>
                {{
                  (payeCostSelected?.total_amount || 0) -
                    totalValueWithoutInterest | customCurrencyLight
                }}
              </p>
            </div>

            <div class="payment-resume-total">
              <p>
                Melhor preço (PIX)
                <ng-container
                  *ngIf="budget.cart?.percentDiscountTotal || 0 > 0"
                >
                  <i style="color: #e24c4c; font-style: normal">
                    &nbsp;c/ {{ budget.cart?.percentDiscountTotal }}% de
                    desconto
                  </i>
                </ng-container>
              </p>
              <p>{{ getFinalValue() || 0 | customCurrencyLight }}</p>
            </div>
          </div>
          <button
            (click)="onClickCheckout()"
            title="Realizar o pagamento e finalizar sua compra"
            class="button-rm"
            aria-label="Realizar o pagamento e finalizar sua compra"
          >
            FINALIZAR SUA COMPRA
          </button>
        </div>
      </div>
      <div class="payment-main-content-resume">
        <h2>RESUMO DA COMPRA</h2>
        <div class="payment-resume-main">
          <div class="payment-resume-products">
            <a
              href="{{ item?.product?.url }}"
              target="_blank"
              class="payment-resume-products-item"
              *ngFor="let item of cartCheckout?.cart?.cartProducts"
            >
              <div class="payment-resume-products-item-description">
                <img
                  [src]="item?.product?.photos?.slice()?.shift()?.url"
                  [alt]="item?.product?.name"
                  width="80"
                  height="80"
                />
                <div class="payment-resume-products-item-text">
                  <p>
                    {{ item?.product?.name }}
                    <span *ngIf="item?.product?.productPerSquareMeter">
                      {{
                        item?.product?.productPerSquareMeter
                          ? "Largura: " +
                            item?.customWidth?.toFixed(2) +
                            "m x Altura: " +
                            item?.customHeight?.toFixed(2) +
                            "m"
                          : ""
                      }}
                    </span>

                    <span *ngIf="item?.product?.isPersiana()">
                      {{ item?.driveDescription }}
                      | {{ item?.controlSideDescription }}
                      {{
                        item?.product?.isPersianaRomana()
                          ? ""
                          : " | " + item?.panelDescription
                      }}
                    </span>

                    <span>
                      {{ "Marca: " + item?.product?.brandDescription || "" }} -
                      {{ "Código: " + item?.product?.id }}</span
                    >
                  </p>
                  <div class="payment-resume-products-item-value">
                    <p>Quantidade: {{ item.amount }}</p>
                    <p>
                      <span *ngIf="item.discount">
                        {{ item.gross | customCurrencyLight }}
                      </span>
                      &nbsp;&nbsp;{{ item.total | customCurrencyLight }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-footer-infos">
    <a target="_blank" href="politicas-trocas-cancelamentos"
      >Trocas, Devoluções e Políticas de Entrega</a
    >
    <a target="_blank" href="termos-condicoes-uso">Termos e Condições</a>
    <a target="_blank" href="aviso-de-privacidade">Aviso de Privacidade</a>
    <a target="_blank" href="faq">Perguntas Frequentes</a>
    <a target="_blank" href="fale-conosco">Fale Conosco</a>
  </div>
</div>
<app-modal-pix
  [order]="order"
  [pix]="pix"
  [showCountDown]="true"
  [visible]="showModalPix"
  (closeModal)="closeModalPix()"
  (paymentAccept)="userService.goToCustomerOrders()"
></app-modal-pix>
